import { channelColorMap } from '@/pages/opinion/constants';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import { compareKeyMetricsEngagementTips } from '@op/components/BubbleCommon';

export const norms = [
  {
    value: 'follower_number',
    text: 'Followers',
    params: 'followers',
  },
  {
    value: 'posts',
    text: 'Posts-1',
    select: false, // 不参与 select 选择
    params: 'posts',
  },
  {
    value: 'engagement',
    text: 'Engagements',
    params: 'engagements',
    tips: compareKeyMetricsEngagementTips,
  },
  {
    value: 'tweets_like',
    text: 'Likes',
    params: 'likes',
  },
  {
    value: 'tweets_reply',
    text: 'Comments',
    params: 'comments',
  },
  {
    value: 'share',
    text: 'Shares',
    params: 'shares',
  },
];

export const postSelectOptions = norms.slice(2);

export const chooseSelectOptions = [
  {
    value: 'followers',
    text: 'Followers',
  },
  {
    value: 'engagements',
    text: 'Engagements',
  },

  {
    value: 'posts',
    text: 'Posts-1',
  },
  {
    value: 'likes',
    text: 'Likes',
  },
  {
    value: 'comments',
    text: 'Comments',
  },
  {
    value: 'shares',
    text: 'Shares',
  },
];

// channelColorMap

const channelColorTextKeys = [
  {
    legendName: 'facebook',
    key: 'facebook',
  },
  {
    legendName: 'twitter',
    key: 'twitter',
  },
  {
    legendName: 'instagram',
    key: 'instagram',
  },
  {
    legendName: 'reddit',
    key: 'reddit',
  },
  {
    legendName: 'tiktok',
    key: 'tiktok',
  },
  {
    legendName: 'youtube',
    key: 'youtube',
  },
  {
    legendName: 'twitch',
    key: 'twitch',
  },
  {
    legendName: 'discord',
    key: 'discord',
  },
  {
    legendName: 'vk',
    key: 'vk',
  },
  {
    legendName: 'navergame',
    key: 'navergame',
  },
  {
    legendName: 'navercafe',
    key: 'navercafe',
  },
  {
    legendName: 'kwai',
    key: 'kwai',
  },
  {
    legendName: 'Others',
    key: 'others',
  },
];

export const channelColorTextMap: any = channelColorTextKeys.reduce(
  (obj, cur) => {
    const curObj: any = { ...obj };
    curObj[cur.key] = {
      color: channelColorMap[cur.key] || '#387F7D',
      legendName: cur.legendName,
    };
    return curObj;
  },
  {},
);

export const pageMaps: any = {
  channel: {
    defaultNavigator: 'Channel Trends',
    pageTitle: 'By Channel',
    navigators: [], // 使用全部社媒channel为默认导航，所以去掉了
  },
  account: {
    defaultNavigator: 'Account Trends',
    pageTitle: 'By Account',
    navigators: [
      {
        symbol: 'Top 1 Account',
      },
      {
        symbol: 'Top 2 Account',
      },
      {
        symbol: 'Top 3 Account',
      },
    ],
  },
};

export const tabOptions = [
  { text: 'Engagements', value: 'engagements' },
  { text: 'Likes', value: 'likes' },
  { text: 'Comments', value: 'comments' },
  { text: 'Shares', value: 'shares' },
  { text: 'Views', value: 'views' },
];

export const tabMap = arrayToSimpleObj(tabOptions);

export const showTargetItems = [
  'followers',
  'posts',
  'engagements',
  'likes',
  'comments',
  'shares',
  'views',
];
